import { combineReducers, Reducer } from "redux";
import * as _ from "./index";

export interface IRootState {
  prayerTimes: _.IPrayerTimesState;
  dailyDuas: _.IDuasState;
  configuration: _.IConfigurationState;
}

const createRootReducer: () => Reducer<IRootState> = (): Reducer<IRootState> =>
  combineReducers<IRootState>({
    prayerTimes: _.prayerTimesReducer,
    dailyDuas: _.duasReducer,
    configuration: _.configurationReducer,
  });

export default createRootReducer;
